/* RESPONSIBLE TEAM: team-conversations */
export default class TextNode {
  constructor(value) {
    this.value = value;
    this.type = 'text';
  }
}
